// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBJDQ1HE5-isNy53IfmkqzNrOxf_xaCa8c",
    authDomain: "hayaan-dev.firebaseapp.com",
    projectId: "hayaan-dev",
    storageBucket: "hayaan-dev.appspot.com",
    messagingSenderId: "643122766348",
    appId: "1:643122766348:web:9cb266187b193e69784429"
  },
  evcMerchantNumber: 647352,
}
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

